import {
	axiosInstance,
	axiosJsonInstance,
	axiosJsonDirectInstance,
	axiosNoContentTypeInstance
} from "@/axios.instance";
import { MapSetupItem } from "@/store/map-setup/types";
import { AxiosInstance, AxiosResponse } from "axios";
import { Map } from "@/store/map-setup/types";
import { MapItemData, MapLayerData } from "@/store/map-layers/types";
import ConvertMapActionsRequest from "@/types/request/ConvertMapActionsRequest";
class MapSetupApi {
	private axios: AxiosInstance | undefined;
	private axiosJson: AxiosInstance | undefined;
	private axiosPost: AxiosInstance | undefined;
	private axiosJsonDirectInstance: AxiosInstance | undefined;
	private axiosNoContentTypeInstance: AxiosInstance | undefined;

	constructor() {
		this.axios = axiosInstance;
		this.axiosJson = axiosJsonInstance;
		this.axiosJsonDirectInstance = axiosJsonDirectInstance;
		this.axiosNoContentTypeInstance = axiosNoContentTypeInstance;
	}

	public async addUpdateMapLayer(mapLayer: FormData) {
		return await this.axiosNoContentTypeInstance.put("/MapLayers", mapLayer, {
			headers: {
				"Content-Type": "multipart/form-data"
			}
		});
	}

	public async deleteMapLayer(mapLayerId: number): Promise<any> {
		return await this.axiosJson!.delete(`/MapLayers/${mapLayerId}`);
	}

	public async updateAreaLatLong(groupId: number, latlong: any): Promise<any> {
		await this.axios!.post(`/groups/UpdateLatLong/${groupId}`, latlong);
	}

	public async updateMapLayerItem(mapLayerItem: MapSetupItem) {
		return await this.axiosJson!.put("/MapLayers/MapItems", mapLayerItem);
	}

	public async deleteMapLayerItem(mapLayerItemId: number): Promise<any> {
		return await this.axiosJson!.delete(`/MapLayers/MapItems/${mapLayerItemId}`);
	}

	public async loadUnconvertedMaps(groupId: number): Promise<AxiosResponse<Map[]>> {
		return await this.axios!.get(`/Map/UnconvertedMaps/${groupId}`);
	}

	public async deleteUnconvertedMap(mapId: number): Promise<AxiosResponse> {
		return await this.axios.delete(`/Map/${mapId}`);
	}

	public async convertMap(mapLayer: Partial<MapLayerData>): Promise<AxiosResponse<number>> {
		return await this.axios!.post("/Map/ConvertToMapLayer", mapLayer);
	}

	public async PreviewConvertMap(paylaod: ConvertMapActionsRequest): Promise<AxiosResponse<MapItemData[]>> {
		return await this.axios!.post("/Map/ConvertMapActions", paylaod);
	}
}

const mapSetupApi = new MapSetupApi();
export default mapSetupApi;
